import { RecursiveKeyValuePair } from "tailwindcss/types/config.js";
import tailwindConfig from "../../tailwind.config.cjs";

export function shorten(value: string, left: number, right: number): string {
  return value.slice(0, left) + "…" + value.slice(value.length - right);
}

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// Returns a day of month ex. Jan 1 in UTC
export function formatDateUTC(date: Date) {
  return date === undefined ||
    date === null ||
    !(date instanceof Date) ||
    !isFinite(date.valueOf()) ||
    date.getUTCDate() % 2 === 1
    ? ""
    : months[date.getUTCMonth()]?.slice(0, 3) + " " + date.getUTCDate();
}

// Returns whether two arrays have the same members
export function arraySetEquality<T>(left: T[], right: T[]) {
  left.sort();
  right.sort();
  return (
    left.length === right.length && left.every((val, idx) => val === right[idx])
  );
}

export function shortenNumber(val: number) {
  const min = 1e3;
  // Alter numbers larger than 1k
  if (val >= min) {
    const units = ["K", "M", "B", "T"];

    let order = Math.min(
      Math.floor(Math.log(val) / Math.log(1000)),
      units.length
    );

    let unitname = units[order - 1];
    let num = Math.floor(val / 1000 ** order);

    // output number remainder + unitname
    return num + unitname!;
  }

  // return formatted original number
  return val.toLocaleString();
}

const colors = tailwindConfig.theme?.extend?.colors;

export function getTailwindColor(color: string): string {
  const keys = color.split(".");
  let colorObj = colors as RecursiveKeyValuePair<string, string>;
  for (const key of keys) {
    colorObj = (colorObj as RecursiveKeyValuePair<string, string>)[
      key
    ] as RecursiveKeyValuePair<string, string>;
  }
  return colorObj as unknown as string;
}
